import WarningTriangle from "./SVG/warning-triangle.svg?react";

const WarningTriangleIcon = () => {
  return <WarningTriangle />;
};

export default WarningTriangleIcon;
